import React from 'react';
import PropTypes from 'prop-types';
import { compose, withProps } from 'recompose';
import { withStyles } from 'material-ui/styles';
import Typography from 'material-ui/Typography';
import BaseObjectField from '../BaseObjectField';

const styles = theme => ({
  header: {
    padding: theme.spacing.unit * 2,
  },
});

const TabComponent = props => {
  const { classes, schema, uiSchema, children } = props;
  const uiOptions = uiSchema['ui:options'];
  const displayTitle = uiOptions && uiOptions.displayTitle !== undefined ? uiOptions.displayTitle : true;
  const title =
  displayTitle &&
  (uiSchema['ui:title'] ||
    (schema.title !== undefined ? schema.title : null));
  return (
    <div>
      {title && (
          <header className={classes.header}>
            {title && (
              <Typography type="subheading" gutterBottom>
                {uiSchema['ui:title'] || title}
              </Typography>
            )}
          </header>
        )}
      {children}
    </div>
  );
};

TabComponent.propTypes = {
  classes: PropTypes.object.isRequired,
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array]),
  schema: PropTypes.object.isRequired,
  idSchema: PropTypes.object.isRequired,
  uiSchema: PropTypes.object,
  registry: PropTypes.object.isRequired,
  name: PropTypes.string,
  options: PropTypes.array,
};

TabComponent.defaultProps = {
  options: [],
};

const enhance = compose(
  withProps({
    RootComponent: withStyles(styles)(TabComponent),
    options: [],
  })
);

const TabField = enhance(BaseObjectField);

export default TabField;



// WEBPACK FOOTER //
// ./src/modules/common/components/form/fields/readonly/TabField.js